import api from '../api';

export const getUsers = async (projectId, active = true, deleted = false, all = false) => {
  const res = await api.get(`/projects/${projectId}/users`, { params: { active, deleted, all } });
  return res.data;
};

export const getAllProjectUsers = async () => {
  const res = await api.get(`/users/all-project-users`);
  return res.data;
};

export const activate = async (userId, projectId) => {
  const res = await api.patch(`/users/${userId}/activate`, { projectId });
  return res.data;
}

export const deactivate = async (userId, projectId) => {
  const res = await api.patch(`/users/${userId}/deactivate`, { projectId });
  return res.data;
}

export const deleteUser = async (userId, projectId) => {
  const res = await api.delete(`/users/${userId}`, { projectId } );
  return res.data;
}

export const reAssign = async (userId, roleId, prevRoleId, projectId, approverId) => {
  const body = { roleId, prevRoleId, projectId };
  if (approverId) body.approverId = approverId;
  const res = await api.patch(`/users/${userId}/roles`, body);
  return res.data;
}

export const getAdminUsers = async () => {
  const res = await api.get(`/users/admin-users`);
  return res.data;
};

export const createAdminUser = async (userDetails) => {
  const res = await api.post(`/users/admin-users`, userDetails);
  return res.data;
}

export const updateAdminUser = async ({ id, ...userDetails }) => {
  const res = await api.put(`/users/admin-users/${id}`, userDetails);
  return res.data;
}


export const getProfile = async (id) => {
  const res = await api.get(`/user/${id}/profile`);
  return res.data;
};

export const updateUserPassword = async (userId, currentPassword, newPassword) => {
  const response = await api.put(`/users/${userId}/update-password`, {
      currentPassword,
      newPassword,
    });
  return response.data;
}

export const resetUserPassword = async (userId, newPassword, projectId) => {
  const response = await api.put(`/users/${userId}/reset-password`, {
      newPassword,
      projectId
    });
  return response.data;
}